var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditPencilPaperGray = function SvgEditPencilPaperGray(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0918 2.29102L22.0918 6.29102L10.0918 18.291H6.0918V14.291L18.0918 2.29102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3847 1.58391C17.7752 1.19338 18.4084 1.19338 18.7989 1.58391L22.7989 5.58391C23.1894 5.97443 23.1894 6.6076 22.7989 6.99812L10.7989 18.9981C10.6114 19.1857 10.357 19.291 10.0918 19.291H6.0918C5.53951 19.291 5.0918 18.8433 5.0918 18.291V14.291C5.0918 14.0258 5.19715 13.7714 5.38469 13.5839L17.3847 1.58391ZM7.0918 14.7052V17.291H9.67758L20.6776 6.29102L18.0918 3.70523L7.0918 14.7052Z",
    fill: "#576777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5919 3.87695L20.5062 8.79117L19.0919 10.2054L14.1777 5.29117L15.5919 3.87695Z",
    fill: "#576777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0918 3.29102C1.0918 2.73873 1.53951 2.29102 2.0918 2.29102H11.0918C11.6441 2.29102 12.0918 2.73873 12.0918 3.29102C12.0918 3.8433 11.6441 4.29102 11.0918 4.29102H3.0918V21.291H20.0918V13.291C20.0918 12.7387 20.5395 12.291 21.0918 12.291C21.6441 12.291 22.0918 12.7387 22.0918 13.291V22.291C22.0918 22.8433 21.6441 23.291 21.0918 23.291H2.0918C1.53951 23.291 1.0918 22.8433 1.0918 22.291V3.29102Z",
    fill: "#576777"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditPencilPaperGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-pencil-paper-gray.b7a77c5c.svg";
export { ForwardRef as ReactComponent };